import React from 'react';
import PropTypes from 'prop-types';
import './ScreenSectionsSkeleton.css';

const ScreenSectionsSkeleton = ({
  leftSections = 3,
  rightSections = 3,
  className = ''
}) => {
  return (
    <div className={`sss-layout ${className}`.trim()}>
      <div className="sss-left">
        {Array.from({ length: Math.max(1, leftSections) }).map((_, idx) => (
          <div key={`sss-left-${idx}`} className="sss-card">
            <span className="sss-shimmer sss-title" />
            <div className="sss-grid3">
              <span className="sss-shimmer sss-box" />
              <span className="sss-shimmer sss-box" />
              <span className="sss-shimmer sss-box" />
            </div>
          </div>
        ))}
      </div>

      <div className="sss-right">
        {Array.from({ length: Math.max(1, rightSections) }).map((_, idx) => (
          <div key={`sss-right-${idx}`} className="sss-card">
            <span className="sss-shimmer sss-title short" />
            <div className="sss-lines">
              <span className="sss-shimmer sss-line" />
              <span className="sss-shimmer sss-line" />
              <span className="sss-shimmer sss-line" />
              <span className="sss-shimmer sss-line" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

ScreenSectionsSkeleton.propTypes = {
  leftSections: PropTypes.number,
  rightSections: PropTypes.number,
  className: PropTypes.string
};

export default ScreenSectionsSkeleton;
